<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="add()">新增</Button>
		</div>
		<div class="query">
			<div class="checkbox">

			</div>
			<Input search enter-button placeholder="请输入广告投放商名称查询" style="width: 500px;" v-model="query.like" @on-blur="likeQuery"/>
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="update(row.id)">详情</Button>
				<Button type="primary" size="small" style="margin-right: 5px" @click="meaterial(row.id)">素材管理</Button>
				
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				loading: false,
				total: 0,
				query: { //查询参数
					page: 0,
					size: 10,
					like:''
				},
				modal2: false,
				modal_loading: false,
				deleteId: '',
				columns12: [{
						type: 'selection',
						width: 60,
						align: 'center'
					}, {
						title: 'id',
						key: 'id'
					},
					{
						title: '公司名称',
						key: 'companyName'
					},
					{
						title: '地址',
						key: 'address'
					},
					{
						title: '联系方式1',
						key: 'phone1'
					},
					{
						title: '联系方式2',
						key: 'phone2'
					},
					{
						title: '联系方式3',
						key: 'phone3'
					},
					{
						title: '邮箱',
						key: 'mailbox'
					},
					{
						title: '录入人',
						key: 'advEmp',
						render: (h, params) => {
								return h("div", params.row.enteringEmpName)
						}
					},
					{
						title: '录入时间',
						key: 'createdTime'
					},
					{
						title: '操作',
						slot: 'action',
						width: 300,
						align: 'center'
					}
				],
				data6: [
					/* 	{
						id: '1',
						companyName: '',
						address: '',
						phone1: '',
						phone2: '',
						phone3: '',
						mailbox: '',
						operType: '',
						state: '',
						createdTime: '2010-10-10'

					}, */
				]

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			update(id) { //修改
				this.$router.push({
					name: 'jm/adv/sponsor/update',
					query: {
						id: id
					}
				})
			},
			meaterial(id){
				this.$router.push({
					name: 'jm/adv/meaterial/list',
					query: {
						id: id
					}
				})
			},
			forbidden(id) {
				this.deleteId = id
				this.modal2 = true
			},
			add() {
				this.$router.push({
					name: 'jm/adv/sponsor/add'
				})
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			likeQuery(){
				this.query.page=0
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				this.$http.post(http.url+'/plat/platAdvSponsor/page', this.query).then(res => {
					let data = res.data
					switch (data.code) {
						case 200:
							console.log(data)
							this.total = data.platAdvSponsor.totalElements
							this.data6 = data.platAdvSponsor.content

							this.loading = false
							break;

						case 1000:
							this.$Message.error('登陆失效，请重新登陆!');
							setTimeout(function() {
								this.$router.push('/login')
							}, 1000);
							break;
						case 100:
							this.$Message.error('服务器异常!');
							break;
						case 101:
							this.$Message.error(data.error);
							break;
						default:
							this.$Message.error('服务器异常!');
							break;
					}

				}, res => {
					this.$Message.error('系统异常请刷新后重试!');
				})
			}

		},
		components: {
			page
		},
		created() {
			this.ajaxPage();
		}


	}
</script>
<style scoped="scoped">
	.ivu-table-cell {
		padding-left: 0px !important;
	}

	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.ivu-table-cell {
		padding-left: 0px;
	}

	.query {
		display: flex;
		justify-content: space-between;
		margin: 20px 0px 20px 0px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/adv/sponsor/list.vue